{
  "title": "Einstellungen",
  "panel": {
    "createTitle": "{{title}} erstellen",
    "updateTitle": "{{title}} aktualisieren",
    "createDescription": "{{title}} erstellen.",
    "updateDescription": "{{title}} aktualisieren.",
    "removeTitle": "{{title}} entfernen",
    "removeText": "Bist du sicher, dass du {{title}} entfernen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
    "closePanel": "Panel schließen",
    "remove": "Entfernen",
    "test": "Testen",
    "ok": "OK!",
    "error": "FEHLER",
    "cancel": "Abbrechen",
    "create": "Erstellen",
    "save": "Speichern"
  },
  "nav": {
    "application": "Anwendung",
    "logs": "Protokolle",
    "indexers": "Indexer",
    "irc": "IRC",
    "feeds": "Feeds",
    "lists": "Listen",
    "clients": "Clients",
    "notifications": "Benachrichtigungen",
    "apiKeys": "API-Schlüssel",
    "proxies": "Proxys",
    "releases": "Releases",
    "account": "Konto"
  },
  "application": {
    "title": "Anwendung",
    "description": "Anwendungseinstellungen. Nimm Änderungen in config.toml vor und starte die Anwendung neu, damit sie wirksam werden.",
    "host": "Host",
    "port": "Port",
    "baseUrl": "Basis-URL",
    "version": "Version",
    "commit": "Commit",
    "buildDate": "Builddatum",
    "application": "Anwendung",
    "configPath": "Konfigurationspfad",
    "database": "Datenbank",
    "webuiDebugMode": "WebUI-Debugmodus",
    "checkForUpdates": "Nach Updates suchen",
    "checkForUpdatesDescription": "Über neue Updates benachrichtigt werden.",
    "theme": "Design",
    "themeDescription": "Zwischen hellem, dunklem oder Systemdesign wählen.",
    "languageDescription": "Die im WebUI verwendete Sprache wählen.",
    "updateEnabled": "Du wirst jetzt über neue Updates benachrichtigt.",
    "updateDisabled": "Du wirst nicht mehr über neue Updates benachrichtigt.",
    "updateAvailable": "{{name}} verfügbar!"
  },
  "account": {
    "title": "Konto",
    "description": "Kontoeinstellungen verwalten.",
    "required": "Pflichtfeld",
    "passwordsDoNotMatch": "Passwörter stimmen nicht überein!",
    "updateSuccess": "Benutzer erfolgreich aktualisiert. Bitte erneut anmelden!",
    "updateError": "Fehler beim Aktualisieren der Anmeldedaten. Wurde das richtige aktuelle Passwort angegeben?",
    "changeCredentialsTitle": "Anmeldedaten ändern",
    "changeCredentialsDescription": "Benutzername und Passwort können separat oder gleichzeitig geändert werden. Beachte, dass du nach dem Ändern der Anmeldedaten abgemeldet wirst.",
    "currentUsername": "Aktueller Benutzername",
    "newUsername": "Neuer Benutzername",
    "optional": "Optional",
    "currentPassword": "Aktuelles Passwort",
    "requiredIfUpdatingCredentials": "Erforderlich bei Aktualisierung der Anmeldedaten",
    "newPassword": "Neues Passwort",
    "confirmNewPassword": "Neues Passwort bestätigen",
    "save": "Speichern",
    "identityProvider": "deinem Identitätsanbieter",
    "oidcTitle": "OpenID Connect-Konto",
    "oidcDescription": "Deine Kontoanmeldedaten werden von deinem OpenID Connect-Anbieter verwaltet. Um deinen Benutzernamen zu ändern, besuche bitte die Einstellungsseite deines Anbieters und melde dich erneut an.",
    "authenticatedViaOidc": "Über OpenID Connect authentifiziert"
  },
  "logsPage": {
    "title": "Protokolle",
    "description": "Protokollstufe, Protokollgrößenrotation usw. konfigurieren. Alte Protokolldateien unten herunterladen.",
    "chooseType": "Typ wählen",
    "updated": "Konfiguration erfolgreich aktualisiert!",
    "path": "Pfad",
    "setInConfig": "In config.toml festgelegt",
    "notSet": "Nicht festgelegt!",
    "level": "Stufe",
    "logLevel": "Protokollstufe",
    "maxSize": "Max. Größe",
    "maxBackups": "Max. Backups"
  },
  "regexPlayground": {
    "title": "Regex-Spielwiese",
    "description": "Regex-Spielwiese. Hier mit Filtern experimentieren. In Entwicklung.",
    "regexFilter": "Regex-Filter",
    "linesToMatch": "Zu filternde Zeilen",
    "matches": "Treffer"
  },
  "apiKey": {
    "createTitle": "API-Schlüssel erstellen",
    "description": "Neuen API-Schlüssel hinzufügen.",
    "created": "API-Schlüssel {{name}} wurde hinzugefügt",
    "deleted": "API-Schlüssel {{name}} wurde gelöscht",
    "name": "Name",
    "key": "Schlüssel",
    "required": "Pflichtfeld",
    "closePanel": "Panel schließen",
    "cancel": "Abbrechen",
    "create": "Erstellen",
    "listTitle": "API-Schlüssel",
    "listDescription": "Hier autobrr API-Schlüssel verwalten.",
    "addNew": "Neu hinzufügen",
    "noItems": "Keine API-Schlüssel",
    "createCta": "API-Schlüssel erstellen",
    "removeTitle": "API-Schlüssel entfernen: {{name}}",
    "removeText": "Bist du sicher, dass du diesen API-Schlüssel entfernen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
    "deleteKey": "Schlüssel löschen"
  },
  "irc": {
    "listTitle": "IRC",
    "listDescription": "IRC-Netzwerke und Kanäle. Auf ein Netzwerk klicken, um den Kanalstatus anzuzeigen.",
    "addNew": "Neu hinzufügen",
    "networkHealthy": "Netzwerk gesund",
    "networkUnhealthy": "Netzwerk ungesund",
    "networkDisabled": "Netzwerk deaktiviert",
    "collapseTitle": "einklappen",
    "expandTitle": "ausklappen",
    "collapse": "Einklappen",
    "expand": "Ausklappen",
    "network": "Netzwerk",
    "noNetworks": "Keine Netzwerke",
    "noNetworksSubtitle": "Normalerweise über Indexer eingerichtet",
    "addNewNetwork": "Neues Netzwerk hinzufügen",
    "toggleSuccess": "{{name}} wurde erfolgreich {{state}}.",
    "enabledState": "aktiviert",
    "disabledState": "deaktiviert",
    "connectedSince": "Verbunden seit: {{time}}",
    "tlsSecured": "Mit TLS gesichert",
    "tlsInsecure": "Unsicher, kein TLS",
    "channel": "Kanal",
    "monitoringSince": "Überwachung seit",
    "lastAnnounce": "Letzte Ankündigung",
    "monitoring": "Überwachung",
    "hide": "Ausblenden",
    "view": "Anzeigen",
    "networkDeleted": "Netzwerk {{name}} wurde gelöscht",
    "networkRestarted": "{{name}} wurde erfolgreich neu gestartet",
    "removeNetworkTitle": "Netzwerk entfernen: {{name}}",
    "removeNetworkText": "Bist du sicher, dass du dieses Netzwerk entfernen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
    "edit": "Bearbeiten",
    "restart": "Neu starten",
    "delete": "Löschen",
    "announceReprocessed": "Ankündigung zur Neuverarbeitung gesendet!",
    "reprocessAnnounce": "Ankündigung neu verarbeiten",
    "options": "Optionen",
    "scrollOnNewMessage": "Bei neuer Nachricht nach unten scrollen",
    "title": "Netzwerk",
    "addWarning": "NETZWERKE ÜBER INDEXER HINZUFÜGEN! NUR VERWENDEN, WENN NETZWERKE GELÖSCHT WURDEN",
    "added": "IRC-Netzwerk hinzugefügt. Bitte bis zu 30 Sekunden warten, bis das Netzwerk online ist.",
    "addFailed": "IRC-Netzwerk konnte nicht hinzugefügt werden",
    "updated": "{{name}} wurde erfolgreich aktualisiert",
    "deleted": "{{name}} wurde gelöscht.",
    "required": "Pflichtfeld",
    "name": "Name",
    "enabled": "Aktiviert",
    "server": "Server",
    "serverPlaceholder": "Adresse: z.B. irc.server.net",
    "port": "Port",
    "portPlaceholder": "z.B. 6667",
    "tls": "TLS",
    "skipTls": "TLS-Verifizierung überspringen (unsicher)",
    "password": "Passwort",
    "passwordHelp": "Netzwerkpasswort",
    "passwordUpdateHelp": "Netzwerkpasswort, selten verwendet.",
    "nick": "Nick",
    "nickPlaceholderAdd": "Botnick",
    "nickPlaceholderUpdate": "Nick",
    "authAccount": "Authkonto",
    "authAccountPlaceholder": "Authkonto",
    "authPassword": "Authpasswort",
    "inviteCommand": "Einladungsbefehl",
    "channels": "Kanäle",
    "channelsDesc": "Beizutretende Kanäle.",
    "channelsUpdateDesc": "Kanäle werden beim Einrichten von IRC-Indexern hinzugefügt. Nur bearbeiten, wenn du weißt, was du tust.",
    "channelPassword": "Kanalpasswort",
    "remove": "Entfernen",
    "noChannels": "Keine Kanäle!",
    "addChannel": "Kanal hinzufügen",
    "bouncer": "Bouncer (BNC)",
    "bouncerAddress": "Bounceradresse",
    "bouncerAddressHelp": "Adresse: z.B. bouncer.server.net:6697",
    "botMode": "IRCv3 Bot Mode",
    "proxy": "Proxy",
    "proxyDesc": "Einen Proxy für die Verbindung zum IRC-Server festlegen.",
    "selectProxy": "Proxy wählen",
    "selectProxyPlaceholder": "Einen Proxy wählen",
    "identification": "Identifikation",
    "identificationDesc": "Mit SASL oder NickServ identifizieren. Die meisten Netzwerke unterstützen SASL, manche nicht.",
    "mechanism": "Mechanismus",
    "account": "Konto",
    "accountHelp": "NickServ / SASL-Konto. Bei gruppierten Nicks den Hauptnick versuchen.",
    "passwordSaslHelp": "NickServ / SASL-Passwort.",
    "chooseType": "Typ wählen"
  },
  "releases": {
    "warningTitle": "Warnung:",
    "warningBody": "Dieser Bereich verwaltet die Löschung des Releaseverlaufs. Automatisierte Bereinigungsaufgaben laufen nach Zeitplan, während die manuelle Löschung eine sofortige einmalige Bereinigung ermöglicht. Beide Vorgänge löschen Daten dauerhaft und können nicht rückgängig gemacht werden.",
    "olderThan": "Älter als",
    "olderThanDesc": "Wie alt Releases sein müssen, bevor sie gelöscht werden (Erforderlich für automatisierte und manuelle Löschung)",
    "indexers": "Indexer",
    "indexersDesc": "Optionaler Filter (wenn kein Indexer ausgewählt ist, gilt dieser für alle)",
    "releaseStatuses": "Releasestatus",
    "releaseStatusesDesc": "Optionaler Filter (wenn kein Status ausgewählt ist, gilt dieser für alle)",
    "duplicateProfilesTitle": "Releaseduplikatprofile",
    "duplicateProfilesDesc": "Duplikatprofile verwalten.",
    "cleanupJobsTitle": "Releasebereinigungsaufgaben",
    "cleanupJobsDesc": "Automatische Bereinigung alter Releases mit benutzerdefinierten Filtern planen.",
    "addNew": "Neu hinzufügen",
    "edit": "Bearbeiten",
    "enabled": "Aktiviert",
    "name": "Name",
    "lastRun": "Letzter Lauf",
    "nextRun": "Nächster Lauf",
    "runNow": "Jetzt ausführen",
    "delete": "Löschen",
    "never": "Nie",
    "deleteReleaseHistory": "Releaseverlauf löschen",
    "deleteReleaseHistoryDesc": "Die folgenden Kriterien auswählen, um Releaseverlaufsdatensätze dauerhaft zu löschen, die älter als das gewählte Alter sind und optional den ausgewählten Indexern und Releasestatus entsprechen:",
    "removeReleases": "Releases entfernen",
    "invalidAge": "Bitte ein gültiges Alter auswählen.",
    "invalidAgeExample": "Bitte ein gültiges Alter eingeben. Zum Beispiel: 6 Monate oder 1 Jahr.",
    "allDeleted": "Alle Releases basierend auf den Kriterien wurden gelöscht.",
    "olderThanDeleted": "Releases älter als {{duration}} wurden gelöscht.",
    "allIndexers": "alle Indexer",
    "selectedIndexers": "die ausgewählten Indexer",
    "removeCleanupJobTitle": "Bereinigungsaufgabe entfernen: {{name}}",
    "removeCleanupJobText": "Bist du sicher, dass du diese Bereinigungsaufgabe entfernen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
    "cleanupJobToggled": "{{name}} {{state}}",
    "cleanupJobTriggered": "{{name}} ausgelöst",
    "cleanupJobDeleted": "{{name}} gelöscht",
    "cleanupJobEnabled": "aktiviert",
    "cleanupJobDisabled": "deaktiviert",
    "duplicateFieldTitles": {
      "releaseName": "Releasename",
      "hash": "Normalisierter Hash des Releasenamens. Mit Releasename für exakten Treffer verwenden",
      "title": "Geparster Titel",
      "subTitle": "Geparster Untertitel wie Episodenname",
      "group": "Releasegruppe",
      "year": "Jahr",
      "month": "Monat",
      "day": "Tag",
      "source": "Quelle",
      "resolution": "Auflösung",
      "codec": "Codec",
      "container": "Container",
      "dynamicRange": "Dynamikumfang (HDR, DV usw.)",
      "audio": "Audioformate",
      "season": "Staffel",
      "episode": "Folge",
      "website": "Website/Dienst",
      "proper": "Scene Proper",
      "repack": "Scene Repack",
      "edition": "Edition (z.B. Collector's Edition) und Schnitt (z.B. Director's Cut)",
      "language": "Sprache und Region"
    },
    "noDuplicateProfiles": "Keine Releaseduplikatprofile",
    "addNewProfile": "Neues Profil hinzufügen",
    "noCleanupJobs": "Keine Bereinigungsaufgaben",
    "createCleanupSchedules": "Automatisierte Bereinigungszeitpläne erstellen",
    "addNewJob": "Neue Aufgabe hinzufügen",
    "removeReleasesText": "Du bist dabei {{scope}}.",
    "removeReleasesScopeAll": "alle Releaseverlaufsdatensätze für {{indexers}}{{statuses}} zu dauerhaft löschen",
    "removeReleasesScopeOlder": "alle Releaseverlaufsdatensätze älter als {{duration}} für {{indexers}}{{statuses}} dauerhaft zu löschen",
    "removeReleasesStatuses": " und mit folgenden Releasestatus: {{statuses}}",
    "duration": {
      "allTime": "gesamter Zeitraum",
      "hour1": "1 Stunde",
      "hours12": "12 Stunden",
      "day1": "1 Tag",
      "week1": "1 Woche",
      "month1": "1 Monat",
      "months3": "3 Monate",
      "months6": "6 Monate",
      "year1": "1 Jahr",
      "invalid": "Ungültige Dauer"
    }
  },
  "forms": {
    "downloadClient": {
      "remove": "Entfernen",
      "test": "Testen",
      "ok": "OK!",
      "error": "FEHLER",
      "cancel": "Abbrechen",
      "create": "Erstellen",
      "save": "Speichern",
      "added": "Client wurde hinzugefügt",
      "addFailed": "Client konnte nicht hinzugefügt werden",
      "updated": "{{name}} wurde erfolgreich aktualisiert",
      "deleted": "{{name}} wurde gelöscht.",
      "addTitle": "Client hinzufügen",
      "addDescription": "Downloadclient hinzufügen.",
      "editTitle": "Client bearbeiten",
      "editDescription": "Downloadclienteinstellungen bearbeiten.",
      "removeTitle": "Downloadclient entfernen",
      "removeText": "Bist du sicher, dass du diesen Downloadclient entfernen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
      "closePanel": "Panel schließen",
      "name": "Name",
      "enabled": "Aktiviert",
      "type": "Typ",
      "host": "Host",
      "port": "Port",
      "tls": "TLS",
      "skipTls": "TLS-Verifizierung überspringen (unsicher)",
      "username": "Benutzername",
      "password": "Passwort",
      "apiKey": "API-Schlüssel",
      "authToken": "Authentifizierungstoken",
      "basicAuth": "Basic Auth",
      "auth": "Authentifizierung",
      "authType": "Authentifizierungstyp",
      "selectAuthType": "Authentifizierungstyp wählen",
      "authTypeTooltip": "In den meisten Fällen sollte dies Basic Auth sein, aber einige Anbieter verwenden Digest Auth.",
      "hostHelpDeluge": "z.B. client.domain.ltd, domain.ltd/client, domain.ltd:port",
      "hostHelpArr": "Vollständige URL http(s)://domain.ltd und/oder Subdomain/Unterordner",
      "hostHelpQbit": "z.B. http(s)://client.domain.ltd, http(s)://domain.ltd/qbittorrent, http://domain.ltd:port",
      "hostHelpPorla": "z.B. http(s)://client.domain.ltd, http(s)://domain.ltd/porla, http://domain.ltd:port",
      "hostHelpRTorrent": "z.B. http(s)://client.domain.ltd/RPC2, http(s)://domain.ltd/client, http(s)://domain.ltd/RPC2",
      "hostHelpTransmission": "z.B. http(s)://client.domain.ltd, http(s)://domain.ltd/transmission",
      "hostHelpSabnzbd": "z.B. http://ip:port oder https://url.com/sabnzbd",
      "hostHelpNzbget": "z.B. http://localhost:6789",
      "daemonPort": "Daemonport",
      "webUiPortQbit": "WebUI-Port für qBittorrent",
      "transmissionPort": "Port für Transmission",
      "sabnzbdPort": "Port für SABnzbd",
      "guidesDeluge": "Anleitungen für verschiedene Servertypen zur Verbindung mit Deluge in unserer Dokumentation.",
      "guidesArr": "Anleitungen für verschiedene Servertypen zur Verbindung mit der *arr-Suite in unserer Dokumentation.",
      "guidesQbit": "Anleitungen für verschiedene Servertypen zur Verbindung mit qBittorrent in unserer Dokumentation.",
      "guidesRTorrent": "Anleitungen für verschiedene Servertypen zur Verbindung mit rTorrent in unserer Dokumentation.",
      "guidesTransmission": "Anleitungen für verschiedene Servertypen zur Verbindung mit Transmission in unserer Dokumentation.",
      "guidesSabnzbd": "Anleitungen für verschiedene Servertypen zur Verbindung mit SABnzbd in unserer Dokumentation.",
      "dedicatedServers": "Dedizierte Server:",
      "sharedSeedboxProviders": "Gemeinsame Seedboxanbieter:",
      "rulesTitle": "Regeln",
      "rulesDescriptionBasic": "Maximale Downloads verwalten.",
      "rulesDescriptionAdvanced": "Maximale Downloads usw. verwalten.",
      "maxActiveDownloads": "Max. aktive Downloads",
      "maxActiveDownloadsTooltip": "Anzahl der aktiven Downloads begrenzen (0 ist unbegrenzt), um maximale Bandbreite und Speicherplatz für Downloads bereitzustellen.",
      "seeRecommendations": "Empfehlungen für verschiedene Servertypen hier ansehen:",
      "downloadClientTitle": "Downloadclient",
      "downloadClientDescription": "Zu verwendenden Downloadclient überschreiben. Kann auch pro Filteraktion überschrieben werden.",
      "clientName": "Clientname",
      "clientNameTooltip": "Angeben, welchen Client das arr standardmäßig verwenden soll. Kann pro Filteraktion überschrieben werden.",
      "clientIdDeprecated": "Client-ID VERALTET",
      "clientIdDeprecatedTooltip": "VERALTET: Stattdessen das Clientnamefeld verwenden.",
      "ignoreSlowTorrents": "Langsame Torrents ignorieren",
      "ignoreCondition": "Ignorierungsbedingung",
      "selectIgnoreCondition": "Ignorierungsbedingung wählen",
      "ignoreConditionTooltip": "Auswählen, ob die Einstellung für max. aktive Downloads vor der Überprüfung der Geschwindigkeitsschwellen beachtet oder ignoriert werden soll.",
      "downloadSpeedThreshold": "Downloadgeschwindigkeitsschwelle",
      "uploadSpeedThreshold": "Uploadgeschwindigkeitsschwelle",
      "speedThresholdPlaceholder": "in KB/s",
      "downloadSpeedThresholdHelp": "Wenn die Downloadgeschwindigkeit bei Erreichen der maximalen aktiven Downloads darunter liegt, trotzdem herunterladen. KB/s",
      "uploadSpeedThresholdHelp": "Wenn die Uploadgeschwindigkeit bei Erreichen der maximalen aktiven Downloads darunter liegt, trotzdem herunterladen. KB/s"
    },
    "feed": {
      "title": "Feed",
      "updated": "{{name}} wurde erfolgreich aktualisiert",
      "deleted": "{{name}} wurde gelöscht.",
      "testOk": "{{name}} Test OK!",
      "name": "Name",
      "type": "Typ",
      "enabled": "Aktiviert",
      "warningTitle": "Warnung: Indexer könnten dich bei zu niedrigem Intervall sperren!",
      "warningText": "Die Indexerregeln lesen.",
      "url": "URL",
      "torznabUrlHelp": "Torznab-URL. Nur die URL ohne zusätzliche Parameter verwenden.",
      "newznabUrlHelp": "Newznab-URL. Nur die URL ohne zusätzliche Parameter verwenden.",
      "rssUrlHelp": "RSS-URL",
      "urlFormatTitle": "Prowlarr und Jackett haben unterschiedliche Formate:",
      "prowlarr": "Prowlarr",
      "jackett": "Jackett",
      "downloadType": "Downloadtyp",
      "apiKey": "API-Schlüssel",
      "skipTls": "TLS-Verifizierung überspringen (unsicher)",
      "refreshInterval": "Aktualisierungsintervall",
      "refreshIntervalHelp": "Minuten. Empfohlen 15-30. Zu niedrig kann zu einer Sperre führen.",
      "refreshTimeout": "Aktualisierungstimeout",
      "refreshTimeoutHelp": "Sekunden bis zum Abbrechen der Aktualisierung.",
      "maxAge": "Max. Alter",
      "maxAgeHelp": "Maximales Alter des Feedinhalts in Sekunden. 0 verwenden, um den Altersfilter zu deaktivieren und alle Einträge zu verarbeiten.",
      "cookie": "Cookie",
      "cookieHelp": "Nicht häufig verwendet",
      "categoriesTitle": "Kategorien",
      "categoriesDescription": "Verfügbare Kategorien abrufen und auswählen, was einbezogen werden soll.",
      "fetch": "Abrufen",
      "fetching": "Wird abgerufen",
      "refetch": "Erneut abrufen",
      "fetchFailed": "Kategorien konnten nicht abgerufen werden",
      "noCategories": "Keine Kategorien gefunden.",
      "fetchToSelect": "Kategorien zum Auswählen abrufen."
    },
    "list": {
      "added": "Liste hinzugefügt!",
      "addFailed": "Liste konnte nicht hinzugefügt werden",
      "updated": "{{name}} wurde erfolgreich aktualisiert",
      "deleted": "{{name}} wurde gelöscht.",
      "name": "Name",
      "type": "Typ",
      "enabled": "Aktiviert",
      "filters": "Filter",
      "addTitle": "Liste hinzufügen",
      "updateTitle": "Liste aktualisieren",
      "description": "Filter automatisch aus Listen und ARRs aktualisieren.",
      "closePanel": "Panel schließen",
      "chooseType": "Typ wählen",
      "chooseClient": "Client wählen",
      "selectClient": "Client wählen",
      "selectClientLabel": "Client wählen",
      "filtersDescription": "Filter für diese Liste zur Aktualisierung auswählen.",
      "cancel": "Abbrechen",
      "remove": "Entfernen",
      "save": "Speichern",
      "saving": "Speichern...",
      "selectSomeItems": "Auswählen...",
      "allItemsSelected": "Alle Elemente ausgewählt",
      "selectAll": "Alle auswählen",
      "search": "Suchen",
      "noOptions": "Keine Optionen",
      "removeTitle": "{{name}} entfernen",
      "removeText": "Bist du sicher, dass du {{name}} entfernen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
      "required": "Pflichtfeld",
      "settingsLegend": "Einstellungen",
      "source": "Quelle",
      "sourceList": "Quellliste",
      "arrSourceDescription": "Filter aus Titeln in Radarr, Sonarr, Lidarr, Readarr oder Whisparr aktualisieren.",
      "traktSourceDescription": "Eine Traktliste oder eine der Standard-autobrr-gehosteten Listen verwenden.",
      "anilistSourceDescription": "Eine AniListliste aus einer der Standard-autobrr-gehosteten Listen verwenden.",
      "plaintextSourceDescription": "Eine Klartextliste mit einem Element pro Zeile verwenden.",
      "steamSourceDescription": "Steamwunschlisten folgen.",
      "metacriticSourceDescription": "Eine Metacriticliste oder eine der Standard-autobrr-gehosteten Listen verwenden.",
      "mdblistSourceDescription": "Eine MDBListliste oder eine der Standard-autobrr-gehosteten Listen verwenden.",
      "listUrl": "Listen-URL",
      "traktHelp": "Standardmäßige Traktlisten. Mit eigenen überschreiben.",
      "traktApiKey": "API-Schlüssel",
      "traktApiKeyHelp": "Trakt API-Schlüssel. Erforderlich für private Listen.",
      "matchRelease": "Releases filtern",
      "matchReleaseDesc": "Feld 'Releases filtern' verwenden. Verwendet standardmäßig das Filme- und Serienfeld.",
      "includeUnmonitored": "Nicht überwachte einbeziehen",
      "includeUnmonitoredDesc": "Standardmäßig werden nur überwachte Titel gefiltert.",
      "includeAlternateTitles": "Alternative Titel einbeziehen",
      "includeAlternateTitlesDesc": "Alternative Titel in den Filter einbeziehen.",
      "skipCleanSanitize": "Bereinigung und Sanitisierung umgehen und die Liste unverändert verwenden",
      "skipCleanSanitizeDesc": "Standardmäßig werden Titel automatisch bereinigt und auf ungewöhnliche Zeichen überprüft.",
      "tagsIncluded": "Inkludierte Tags",
      "tagsExcluded": "Exkludierte Tags",
      "metacriticHelp": "Metacriticlisten. Mit eigenen überschreiben.",
      "mdblistHelp": "MDBLists.com Listen. Mit eigenen überschreiben.",
      "includeYear": "Jahr einbeziehen",
      "includeYearDesc": "Das Erscheinungsjahr in den Filter für Filme einbeziehen. Erfordert, dass 'Releases filtern' aktiviert ist. Beispiel: Film?Titel?2024*",
      "plaintextUrlHelp": "URL zu einer Klartextdatei mit einem Element pro Zeile",
      "plaintextUrlPlaceholder": "https://example.com/list.txt",
      "plaintextTooltip1": "Klartextlisten können sowohl aus HTTP-URLs als auch aus lokalen Dateien lesen.",
      "plaintextTooltipRemote": "Remote: https://dienst.com/datei.txt",
      "plaintextTooltipLocal": "Lokal: file:///home/benutzername/datei.txt",
      "url": "URL",
      "steamUrlHelp": "Steam-Wunschlisten-URL",
      "steamUrlPlaceholder": "https://store.steampowered.com/wishlist/id/BENUTZERNAME/wishlistdata"
    },
    "proxy": {
      "title": "Proxy",
      "addTitle": "Proxy hinzufügen",
      "addDescription": "Proxy zum Verwenden mit Indexern oder IRC hinzufügen.",
      "added": "Proxy hinzugefügt!",
      "addFailed": "Proxy konnte nicht hinzugefügt werden",
      "updated": "Proxy {{name}} aktualisiert!",
      "updateFailed": "Proxy konnte nicht aktualisiert werden",
      "deleted": "Proxy {{name}} wurde gelöscht.",
      "name": "Name",
      "closePanel": "Panel schließen",
      "enabled": "Aktiviert",
      "proxyType": "Proxytyp",
      "proxyTypeTooltip": "Proxytyp. Üblicherweise SOCKS5.",
      "proxyTypeHelp": "Üblicherweise SOCKS5",
      "addr": "Adresse",
      "addrHelp": "Adresse: schema://ip:port oder schema://domain",
      "user": "Benutzer",
      "userHelp": "Auth: Benutzername",
      "pass": "Passwort",
      "passHelp": "Auth: Passwort",
      "test": "Testen",
      "cancel": "Abbrechen",
      "save": "Speichern"
    },
    "apiKey": {
      "createTitle": "API-Schlüssel erstellen",
      "description": "Neuen API-Schlüssel hinzufügen.",
      "created": "API-Schlüssel {{name}} wurde hinzugefügt",
      "deleted": "API-Schlüssel {{name}} wurde gelöscht",
      "name": "Name",
      "key": "Schlüssel",
      "required": "Pflichtfeld",
      "closePanel": "Panel schließen",
      "cancel": "Abbrechen",
      "create": "Erstellen",
      "listTitle": "API-Schlüssel",
      "listDescription": "Hier autobrr API-Schlüssel verwalten.",
      "addNew": "Neu hinzufügen",
      "noItems": "Keine API-Schlüssel",
      "createCta": "API-Schlüssel erstellen",
      "removeTitle": "API-Schlüssel entfernen: {{name}}",
      "removeText": "Bist du sicher, dass du diesen API-Schlüssel entfernen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
      "deleteKey": "Schlüssel löschen"
    },
    "notification": {
      "settings": "Einstellungen",
      "settingsDescDiscordPrefix": "Erstelle eine ",
      "settingsDescDiscordSuffix": " in deinem Server.",
      "discordWebhookIntegration": "Webhookintegration",
      "settingsDescNotifiarr": "Die autobrr-Integration aktivieren und optional einen neuen API-Schlüssel erstellen.",
      "settingsDescLunasea1": "LunaSea bietet Benachrichtigungen auf allen mit deinem Konto verknüpften Geräten (benutzerbasiert) oder auf einem einzelnen Gerät ohne Konto über einen gerätespezifischen Webhook (gerätebasiert).",
      "settingsDescLunasea2Prefix": "Die ",
      "settingsDescLunasea2Suffix": " lesen.",
      "lunaseaDocs": "LunaSea-Dokumentation",
      "settingsDescTelegramPrefix": "Lies, wie du ",
      "settingsDescTelegramSuffix": ".",
      "createBot": "einen Bot erstellst",
      "settingsDescPushoverPrefix": "Registriere eine neue ",
      "settingsDescPushoverSuffix": " und füge deren API-Token hier hinzu.",
      "pushoverApplication": "Anwendung",
      "eventSounds": "Ereignistöne",
      "eventSoundsDesc": "Benutzerdefinierte Töne pro Ereignis festlegen",
      "settingsDescWebhook": "Ein generisches autobrr JSON-Payload an eine benutzerdefinierte Webhook-URL senden.",
      "added": "Benachrichtigung hinzugefügt!",
      "addFailed": "Benachrichtigung konnte nicht hinzugefügt werden",
      "updated": "{{name}} wurde erfolgreich aktualisiert",
      "deleted": "{{name}} wurde gelöscht.",
      "required": "Pflichtfeld",
      "addTitle": "Benachrichtigungen hinzufügen",
      "addDescription": "Benachrichtigungen bei verschiedenen Ereignissen auslösen.",
      "title": "Benachrichtigung",
      "name": "Name",
      "type": "Typ",
      "enabled": "Aktiviert",
      "chooseType": "Typ wählen",
      "closePanel": "Panel schließen",
      "globalEvents": "Globale Ereignisse",
      "globalEventsDesc": "Standardereignisse auswählen, die global auslösen. Diese können für jeden Filter überschrieben werden. Alle deaktiviert lassen, um diesen Dienst nur für filterspezifische Benachrichtigungen zu verwenden.",
      "perFilterEvents": "Filter-spezifische Ereignisse",
      "perFilterEventsDesc": "Diese Benachrichtigung wird in diesen Filtern verwendet.",
      "notUsedInFilters": "In keinen Filtern verwendet",
      "muted": "Stummgeschaltet",
      "test": "Testen",
      "cancel": "Abbrechen",
      "save": "Speichern",
      "notificationsLegend": "Benachrichtigungen",
      "defaultTone": "Standard (Standardton des Benutzers)",
      "webhookUrl": "Webhook-URL",
      "discordWebhookPlaceholder": "https://discordapp.com/api/webhooks/xx/xx",
      "discordWebhookHelp": "Discordkanal Webhook-URL",
      "notifiarrApiKey": "API-Schlüssel",
      "notifiarrApiKeyHelp": "Notifiarr API-Schlüssel",
      "lunaseaWebhookPlaceholder": "https://notify.lunasea.app/v1/custom/user/TOKEN",
      "lunaseaWebhookHelp": "LunaSea Webhook-URL",
      "botToken": "Bot Token",
      "botTokenHelp": "Bot Token",
      "chatId": "Chat-ID",
      "chatIdHelp": "Chat-ID",
      "messageThreadId": "Nachrichtenthread-ID",
      "messageThreadIdHelp": "Nachrichtenthread (Thema) einer Supergruppe",
      "telegramProxy": "Telegram API-Proxy",
      "telegramProxyHelp": "Reverse-Proxy-Domain für api.telegram.org. Nur nötig, wenn dein Netzwerk die Telegram-API blockiert.",
      "telegramProxyPlaceholder": "http(s)://ip:port",
      "sender": "Absender",
      "senderHelp": "Benutzerdefinierter Absendername oben in der Benachrichtigung",
      "senderPlaceholder": "autobrr",
      "apiToken": "API-Token",
      "apiTokenHelp": "API-Token",
      "userKey": "Benutzerschlüssel",
      "userKeyHelp": "Benutzerschlüssel",
      "priority": "Priorität",
      "pushoverPriorityHelp": "-2, -1, 0 (Standard), 1 oder 2",
      "gotifyUrl": "Gotify-URL",
      "gotifyUrlHelp": "Gotify-URL (ohne /message)",
      "gotifyUrlPlaceholder": "https://some.gotify.server.com",
      "applicationToken": "Anwendungstoken",
      "applicationTokenHelp": "Anwendungstoken",
      "ntfyUrl": "NTFY-URL",
      "ntfyUrlHelp": "NTFY-URL",
      "ntfyUrlPlaceholder": "https://ntfy.sh/mytopic",
      "username": "Benutzername",
      "usernameHelp": "Benutzername",
      "password": "Passwort",
      "passwordHelp": "Passwort",
      "accessToken": "Zugriffstoken",
      "accessTokenHelp": "Zugriffstoken. Diesen oder Benutzername + Passwort verwenden",
      "tags": "Tags",
      "ntfyTagsHelp": "Kommagetrennte Tags/Symbole fur ntfy-Benachrichtigungen",
      "ntfyTagsPlaceholder": "download,arr,white_check_mark",
      "ntfyPriorityHelp": "Max 5, 4, 3 (Standard), 2, 1 Min",
      "url": "URL",
      "urlHelp": "URL",
      "shoutrrrDocsPrefix": "Vollständige Dokumentation ",
      "shoutrrrServices": "Dienste",
      "shoutrrrUrlPlaceholder": "smtp://username:password@host:port/?from=fromAddress&to=recipient1",
      "httpMethod": "HTTP-Methode",
      "httpMethodDefault": "POST (Standard)",
      "httpMethodTooltip": "HTTP-Methode für die Webhookanfrage. Standard ist POST.",
      "webhookPlaceholder": "https://example.com/webhook",
      "customHeaders": "Benutzerdefinierte Header",
      "customHeadersHelp": "Durch Komma getrennte SCHLÜSSEL=Wertpaare (z.B. Authorization=Bearer token,X-Custom=Wert)",
      "customHeadersPlaceholder": "Authorization=Bearer token,X-Custom-Header=Wert"
    },
    "irc": {
      "listTitle": "IRC",
      "listDescription": "IRC-Netzwerke und Kanäle. Auf ein Netzwerk klicken, um den Kanalstatus anzuzeigen.",
      "addNew": "Neu hinzufügen",
      "networkHealthy": "Netzwerk gesund",
      "networkUnhealthy": "Netzwerk ungesund",
      "networkDisabled": "Netzwerk deaktiviert",
      "collapseTitle": "einklappen",
      "expandTitle": "ausklappen",
      "collapse": "Einklappen",
      "expand": "Ausklappen",
      "network": "Netzwerk",
      "noNetworks": "Keine Netzwerke",
      "noNetworksSubtitle": "Normalerweise über Indexer eingerichtet",
      "addNewNetwork": "Neues Netzwerk hinzufügen",
      "toggleSuccess": "{{name}} wurde erfolgreich {{state}}.",
      "enabledState": "aktiviert",
      "disabledState": "deaktiviert",
      "connectedSince": "Verbunden seit: {{time}}",
      "tlsSecured": "Mit TLS gesichert",
      "tlsInsecure": "Unsicher, kein TLS",
      "channel": "Kanal",
      "monitoringSince": "Überwachung seit",
      "lastAnnounce": "Letzte Ankündigung",
      "monitoring": "Überwachung",
      "hide": "Ausblenden",
      "view": "Anzeigen",
      "networkDeleted": "Netzwerk {{name}} wurde gelöscht",
      "networkRestarted": "{{name}} wurde erfolgreich neu gestartet",
      "removeNetworkTitle": "Netzwerk entfernen: {{name}}",
      "removeNetworkText": "Bist du sicher, dass du dieses Netzwerk entfernen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
      "edit": "Bearbeiten",
      "restart": "Neu starten",
      "delete": "Löschen",
      "announceReprocessed": "Ankündigung zur Neuverarbeitung gesendet!",
      "reprocessAnnounce": "Ankündigung neu verarbeiten",
      "options": "Optionen",
      "scrollOnNewMessage": "Bei neuer Nachricht nach unten scrollen",
      "title": "Netzwerk",
      "addWarning": "NETZWERKE ÜBER INDEXER HINZUFÜGEN! NUR VERWENDEN, WENN NETZWERKE GELÖSCHT WURDEN",
      "added": "IRC-Netzwerk hinzugefügt. Bitte bis zu 30 Sekunden warten, bis das Netzwerk online ist.",
      "addFailed": "IRC-Netzwerk konnte nicht hinzugefügt werden",
      "updated": "{{name}} wurde erfolgreich aktualisiert",
      "deleted": "{{name}} wurde gelöscht.",
      "required": "Pflichtfeld",
      "name": "Name",
      "enabled": "Aktiviert",
      "server": "Server",
      "serverPlaceholder": "Adresse: z.B. irc.server.net",
      "port": "Port",
      "portPlaceholder": "z.B. 6667",
      "tls": "TLS",
      "skipTls": "TLS-Verifizierung überspringen (unsicher)",
      "password": "Passwort",
      "passwordHelp": "Netzwerkpasswort",
      "passwordUpdateHelp": "Netzwerkpasswort, selten verwendet.",
      "nick": "Nick",
      "nickPlaceholderAdd": "Botnick",
      "nickPlaceholderUpdate": "Nick",
      "authAccount": "Authkonto",
      "authAccountPlaceholder": "Authkonto",
      "authPassword": "Authpasswort",
      "inviteCommand": "Einladungsbefehl",
      "channels": "Kanäle",
      "channelsDesc": "Beizutretende Kanäle.",
      "channelsUpdateDesc": "Kanäle werden beim Einrichten von IRC-Indexern hinzugefügt. Nur bearbeiten, wenn du weißt, was du tust.",
      "channelPassword": "Kanalpasswort",
      "remove": "Entfernen",
      "noChannels": "Keine Kanäle!",
      "addChannel": "Kanal hinzufügen",
      "bouncer": "Bouncer (BNC)",
      "bouncerAddress": "Bounceradresse",
      "bouncerAddressHelp": "Adresse: z.B. bouncer.server.net:6697",
      "botMode": "IRCv3 Bot Mode",
      "proxy": "Proxy",
      "proxyDesc": "Einen Proxy für die Verbindung zum IRC-Server festlegen.",
      "selectProxy": "Proxy wählen",
      "selectProxyPlaceholder": "Einen Proxy wählen",
      "identification": "Identifikation",
      "identificationDesc": "Mit SASL oder NickServ identifizieren. Die meisten Netzwerke unterstützen SASL, manche nicht.",
      "mechanism": "Mechanismus",
      "account": "Konto",
      "accountHelp": "NickServ / SASL-Konto. Bei gruppierten Nicks den Hauptnick versuchen.",
      "passwordSaslHelp": "NickServ / SASL-Passwort.",
      "chooseType": "Typ wählen"
    },
    "indexer": {
      "title": "Indexer",
      "addTitle": "Indexer hinzufügen",
      "addDescription": "Indexer hinzufügen.",
      "added": "Indexer wurde hinzugefügt",
      "addFailed": "Indexer konnte nicht hinzugefügt werden",
      "updated": "{{name}} wurde erfolgreich aktualisiert",
      "deleted": "{{name}} wurde gelöscht.",
      "indexer": "Indexer",
      "chooseIndexer": "Indexer wählen",
      "required": "Pflichtfeld",
      "defaultValueValidation": "Standardwert, bitte bearbeiten",
      "enabled": "Aktiviert",
      "baseUrl": "Basis-URL",
      "baseUrlHelp": "Basis-URL überschreiben, wenn sie von deinem ISP gesperrt ist.",
      "cancel": "Abbrechen",
      "save": "Speichern",
      "closePanel": "Panel schließen",
      "ircTitle": "IRC",
      "ircDesc": "Netzwerke und Kanäle werden automatisch im Hintergrund konfiguriert.",
      "torznabTitle": "Torznab",
      "torznabDesc": "Torznabfeed",
      "newznabTitle": "Newznab",
      "newznabDesc": "Newznabfeed",
      "rssTitle": "RSS",
      "rssDesc": "RSS-Feed",
      "settingsIrcTitle": "IRC",
      "settingsIrcDesc": "Netzwerke und Kanäle werden automatisch im Hintergrund konfiguriert.",
      "ircGuideTooltip": "Bitte das IRC-Handbuch lesen, wenn du nicht mit IRC vertraut bist.",
      "name": "Name",
      "url": "URL",
      "torznabUrlHelp": "Torznab-URL. Nur die URL ohne zusätzliche Parameter verwenden.",
      "newznabUrlHelp": "Newznab-URL. Nur die URL ohne zusätzliche Parameter verwenden.",
      "urlFormatTitle": "Prowlarr und Jackett haben unterschiedliche Formate:",
      "prowlarr": "Prowlarr",
      "jackett": "Jackett",
      "apiKey": "API-Schlüssel",
      "downloadType": "Downloadtyp",
      "downloadTypeTooltip": "Einige Feeds müssen auf Magnet erzwungen werden.",
      "downloadTypeHelp": "Je nach Indexer auf Torrent oder Magnet einstellen.",
      "downloadTypeTooltip2": "Einige Feeds müssen auf Magnet erzwungen werden.",
      "categoriesTitle": "Kategorien",
      "categoriesDescription": "Verfügbare Kategorien abrufen und auswählen, was einbezogen werden soll.",
      "fetch": "Abrufen",
      "fetching": "Wird abgerufen",
      "refetch": "Erneut abrufen",
      "fetchFailed": "Kategorien konnten nicht abgerufen werden",
      "fetchNeedsUrl": "URL eingeben, um Kategorien abzurufen",
      "noCategories": "Keine Kategorien gefunden.",
      "fetchToSelect": "Kategorien zum Auswählen abrufen.",
      "testApi": "API testen",
      "testApiSuccess": "API-Test erfolgreich!",
      "ok": "OK!",
      "error": "FEHLER",
      "externalIdentifier": "Externer Bezeichner",
      "externalIdentifierHelp": "Externer Bezeichner für ARRs. Bei Verwendung von Prowlarr wie folgt einstellen: {{name}} (Prowlarr)",
      "externalIdentifierTooltip1": "Externer Bezeichner für ARRs, um Funktionen wie Seedlimits zum Laufen zu bringen.",
      "externalIdentifierTooltip2": "Muss mit dem Indexernamen in deinem ARR übereinstimmen. Bei Verwendung von Prowlarr ist es wahrscheinlich \"{{name}} (Prowlarr)\"",
      "secretFieldTooltip": "Dieses Feld nimmt keine vollständige URL. Nur alphanumerische Zeichenketten wie uqcdi67cibkx3an8cmdm verwenden.",
      "proxy": "Proxy",
      "proxyDesc": "Einen Proxy für Downloads von Torrentdateien und Feeds festlegen.",
      "selectProxy": "Proxy wählen",
      "selectProxyPlaceholder": "Einen Proxy wählen",
      "chooseType": "Typ wählen",
      "editFeeds": "RSS-Feeds unter Einstellungen -> Feeds bearbeiten"
    },
    "releaseProfile": {
      "title": "Duplikatprofil",
      "added": "Profil wurde hinzugefügt",
      "addFailed": "Profil konnte nicht hinzugefügt werden",
      "deleted": "Profil {{name}} wurde gelöscht!",
      "fields": {
        "name": "Name",
        "releaseName": "Releasename",
        "hash": "Hash",
        "title": "Titel",
        "subTitle": "Untertitel",
        "year": "Jahr",
        "month": "Monat",
        "day": "Tag",
        "source": "Quelle",
        "resolution": "Auflösung",
        "codec": "Codec",
        "container": "Container",
        "dynamicRange": "Dynamikumfang",
        "audio": "Audio",
        "group": "Gruppe",
        "season": "Staffel",
        "episode": "Folge",
        "website": "Website/Dienst",
        "proper": "Proper",
        "repack": "Repack",
        "edition": "Edition",
        "hybrid": "Hybridversion",
        "language": "Sprache"
      },
      "descriptions": {
        "releaseName": "Vollständiger Releasename",
        "hash": "Normalisierter Hash des Releasenamens. Mit Releasename für exakten Treffer verwenden",
        "title": "Geparster Titel",
        "subTitle": "Geparster Untertitel wie Episodenname",
        "dailyReleases": "Für tägliche Releases",
        "group": "Releasegruppe",
        "website": "Dienste wie AMZN/HULU/NF",
        "dynamicRange": "Dynamikumfang (HDR, DV usw.)",
        "edition": "Edition und Schnitt",
        "language": "Sprache und Region"
      }
    },
    "cleanupJob": {
      "title": "Bereinigungsaufgabe",
      "created": "Bereinigungsaufgabe erstellt",
      "createFailed": "Aufgabe konnte nicht erstellt werden",
      "updated": "Aufgabe aktualisiert",
      "updateFailed": "Aufgabe konnte nicht aktualisiert werden",
      "deleted": "{{name}} gelöscht",
      "enableDesc": "Diese Bereinigungsaufgabe aktivieren",
      "namePlaceholder": "Wöchentliche Bereinigung",
      "schedule": "Zeitplan (Cron)",
      "schedulePlaceholder": "0 3 * * *",
      "scheduleHelp": "Cronausdruck. Beispiele: '0 3 * * *' = täglich 3 Uhr, '0 */6 * * *' = alle 6 Stunden",
      "olderThan": "Älter als",
      "olderThanPlaceholder": "30",
      "olderThanHelp": "Releases löschen, die älter als diese Dauer sind",
      "indexersOptional": "Indexer (Optional)",
      "statusesOptional": "Status (Optional)",
      "leaveEmptyIndexers": "Leer lassen, um auf alle Indexer anzuwenden",
      "leaveEmptyStatuses": "Leer lassen, um auf alle Status anzuwenden",
      "executionHistory": "Ausführungshistorie",
      "lastRun": "Letzter Lauf:",
      "status": "Status:"
    }
  },
  "listScreens": {
    "common": {
      "enabled": "Aktiviert",
      "name": "Name",
      "type": "Typ",
      "edit": "Bearbeiten",
      "addNew": "Neu hinzufügen",
      "unknownError": "Ein unbekannter Fehler ist aufgetreten"
    },
    "downloadClients": {
      "title": "Downloadclients",
      "description": "Downloadclients verwalten.",
      "host": "Host",
      "noItems": "Keine Downloadclients",
      "addNewItem": "Neuen Client hinzufügen",
      "toggleSuccess": "{{name}} wurde erfolgreich {{state}}.",
      "enabledState": "aktiviert",
      "disabledState": "deaktiviert"
    },
    "notifications": {
      "title": "Benachrichtigungen",
      "description": "Benachrichtigungsdienste und ihre globalen Ereignisauslöser konfigurieren.",
      "events": "Ereignisse",
      "filters": "Filter",
      "noItems": "Keine Benachrichtigungen",
      "addNewItem": "Neue Benachrichtigung erstellen",
      "infoTitle": "Filter-spezifische Überschreibungen:",
      "infoBody": "Diese globalen Einstellungen können für bestimmte Filter im Benachrichtigungstab jedes Filters überschrieben werden. Globale Ereignisse sind optional – Benachrichtigungsdienste können ohne Ereignisse erstellt und nur auf Filterebene konfiguriert werden. Systemereignisse (IRC getrennt/verbunden, Appupdates) verwenden immer globale Einstellungen.",
      "toggleSuccess": "{{name}} wurde erfolgreich {{state}}.",
      "enabledState": "aktiviert",
      "disabledState": "deaktiviert"
    },
    "indexers": {
      "title": "Indexer",
      "description": "Indexereinstellungen für IRC-, RSS-, Newznab- und Torznab-basierte Indexer.",
      "descriptionGeneric": "Generische RSS/Newznab/Torznab-Feeds können hier durch Auswahl eines der <strong>Generischen</strong> Indexer hinzugefügt werden.",
      "implementation": "Implementierung",
      "noItems": "Keine Indexer",
      "addNewItem": "Neuen Indexer hinzufügen",
      "updated": "{{name}} wurde erfolgreich aktualisiert"
    },
    "proxies": {
      "title": "Proxys",
      "description": "Proxys, die mit Indexern, Feeds und IRC verwendet werden können.",
      "noItems": "Keine Proxys",
      "addNewItem": "Neuen Proxy hinzufügen",
      "toggleSuccess": "Proxy {{name}} wurde erfolgreich {{state}}.",
      "toggleError": "Proxystatus konnte nicht aktualisiert werden",
      "enabledState": "aktiviert",
      "disabledState": "deaktiviert"
    },
    "lists": {
      "title": "Listen",
      "description": "Listen können Filter automatisch aus ARRs oder anderen Quellen aktualisieren.",
      "filters": "Filter",
      "noItems": "Keine Listen",
      "addNewItem": "Neue Liste hinzufügen",
      "toggleSuccess": "Liste {{name}} wurde erfolgreich {{state}}.",
      "toggleError": "Listenstatus konnte nicht aktualisiert werden",
      "refreshSuccess": "Liste {{name}} wurde erfolgreich abgerufen.",
      "refreshError": "{{name}} konnte nicht aktualisiert werden. Fehler: {{error}}",
      "deleted": "{{name}} wurde gelöscht.",
      "removeTitle": "Liste entfernen: {{name}}",
      "removeText": "Bist du sicher, dass du diese Liste entfernen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
      "copyId": "Listen-ID kopieren",
      "copyIdSuccess": "Listen-ID {{id}} in Zwischenablage kopiert.",
      "refresh": "Aktualisieren",
      "delete": "Löschen",
      "enabledState": "aktiviert",
      "disabledState": "deaktiviert"
    },
    "feeds": {
      "title": "Feeds",
      "description": "RSS-, Newznab- und Torznab-Feeds verwalten.",
      "lastRun": "Letzter Lauf",
      "nextRun": "Nächster Lauf",
      "noItems": "Keine Feeds",
      "noItemsDesc": "Über Indexer einrichten",
      "toggleSuccess": "{{name}} wurde erfolgreich {{state}}.",
      "enabledState": "aktiviert",
      "disabledState": "deaktiviert",
      "deleted": "Feed {{name}} wurde gelöscht",
      "cacheCleared": "Feed {{name}} Cache wurde geleert!",
      "forceRunSuccess": "Feed {{name}} wurde erfolgreich erzwungen ausgeführt.",
      "forceRunError": "{{name}} konnte nicht erzwungen ausgeführt werden. Fehler: {{error}}",
      "removeTitle": "Feed entfernen: {{name}}",
      "removeText": "Bist du sicher, dass du diesen Feed entfernen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
      "removeCacheTitle": "Feedcache entfernen: {{name}}",
      "removeCacheText": "Bist du sicher, dass du den Feedcache entfernen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
      "forceRunTitle": "Feed erzwingen: {{name}}",
      "forceRunText": "Bist du sicher, dass du den {{name}}-Feed erzwingen möchtest? Die Einhaltung der RSS-Intervallregeln ist wichtig, um mögliche IP-Sperren zu vermeiden.",
      "toggle": "Umschalten",
      "forceRun": "Erzwingen",
      "viewLatestRun": "Letzten Lauf anzeigen",
      "clearCache": "Feedcache leeren",
      "clearCacheTitle": "Gesamten Feedcache manuell leeren",
      "delete": "Löschen"
    }
  }
}
